// TODO: get all possible parameters and type it in the next phase (final touch)

export const convertNameValue = (parameters: any): any => {
  if (!parameters?.length) return
  return parameters.reduce((prev, currentVal) => {
    prev[currentVal.name] = currentVal.value
    return prev
  }, {})
}
